//Vanila JS plugin boilerplate
//ref; https://github.com/ccurtin/vanilla-js-plugin-boilerplate/blob/basic-template/index.js
(function (root, factory) {
  var pluginName = 'bstackSlider';

  if (typeof define === 'function' && define.amd) {
    define([], factory(pluginName));
  } else if (typeof exports === 'object') {
    module.exports = factory(pluginName);
  } else {
    root[pluginName] = factory(pluginName);
  }
})(this, function (pluginName) {

  var defaults = {
    selector: '.bstack-slider-container',
    cssClass: [],
    rows: 1,
    showDots: false,
    autoplay: false,
    gap: {
      1300: 0,
      980: 0,
      640: 0,
      320: 0
    },
    slide: {
      1300: 1,
      980: 1,
      640: 1,
      320: 1
    },
    cardsInSlide: {
      1300: 1,
      980: 1,
      640: 1,
      320: 1
    },
  };

  /**
   * Merge defaults with user options
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   */
  var extend = function (target, options) {
    var prop,
      extended = {};
    for (prop in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
        extended[prop] = defaults[prop];
      }
    }
    for (prop in options) {
      if (Object.prototype.hasOwnProperty.call(options, prop)) {
        extended[prop] = options[prop];
      }
    }
    return extended;
  };

  /**
   * Plugin Object
   * @param {Object} options User options
   * @constructor
   */
  function Plugin(options) {
    this.options = extend(defaults, options);

    // Add a new option to control whether to slide one card at a time when odd number of cards
    this.options.emptySpaceInLastSlide = options.emptySpaceInLastSlide || false;

    this.slideIndex = 0;

    this.init(); // Initialization Code Here
  }

  function showDivs(n) {
    var i;
    var x = document.getElementsByClassName("mySlides");
    //get the list of dots
    var y = document.getElementById("js-slider-dots").children;
      if (n > x.length) { slideIndex = 1 }
      if (n < 1) { slideIndex = x.length }
      for (i = 0; i < x.length; i++) {
          x[i].style.display = "none";
          //remove .active from all dots
          y[i].classList.remove("active")
      }
      x[slideIndex - 1].style.display = "block";
      //add .active to the selected dot
      y[slideIndex - 1].classList.add("active")
    }

  /**
   * Plugin prototype
   * @public
   * @constructor
   */
  Plugin.prototype = {
    init: function () {
      // Select the carousel you'll need to manipulate and the buttons you'll add events to
      var thatP = this, 
        sel = document.querySelector(this.options.selector);
      if (!sel) {
        return;
      }

      var carousel = sel.querySelector("[data-target='carousel']"),
        card = sel.querySelector("[data-target='card']"),
        cards = sel.querySelectorAll("[data-target='card']"),
        leftButton = sel.querySelector("[data-action='slideLeft']"),
        rightButton = sel.querySelector("[data-action='slideRight']");

      var carouselWidth = carousel.offsetWidth,
      cardStyle = card.currentStyle || window.getComputedStyle(card),
      cardMarginRight = Number(cardStyle.marginRight.match(/\d+/g)[0]),
      cardCount = carousel.querySelectorAll("[data-target='card']").length,
      cardHeight = carousel.querySelector("[data-target='card']").offsetHeight;
      
      // Define an offset property to dynamically update by clicking the button controls
      // as well as a maxX property so the carousel knows when to stop at the upper limit
      var slide = 1, gap = 0, numberOfCards = 0;
      if (window.innerWidth >= 1300) {
        slide = this.options.slide[1300];
        gap = this.options.gap[1300];
        numberOfCards = this.options.cardsInSlide[1300];
      } else if (window.innerWidth >= 980) {
        slide = this.options.slide[980];
        gap = this.options.gap[980];
        numberOfCards = this.options.cardsInSlide[980];
      } else if (window.innerWidth >= 640) {
        slide = this.options.slide[640];
        gap = this.options.gap[640];
        numberOfCards = this.options.cardsInSlide[640];
      } else if (window.innerWidth >= 320) {
        slide = this.options.slide[320];
        gap = this.options.gap[320];
        numberOfCards = this.options.cardsInSlide[320];
      }

      if (slide == 0) {
        return;
      }

      cardCount = Math.ceil(cardCount/this.options.rows);

      var offset = 0, touchstartX = 0, touchendX = 0,
      maxSlide = Math.ceil(cardCount/slide);
      
      if (thatP.options.showDots) {
        if (!sel.querySelector(".bstack-slider-dots .bstack-slider-dots-span")) {
          for (var i = 0; i <= maxSlide - numberOfCards; i++) {
            var dotNumber = i + 1,
            dot = document.createElement('span');
            dot.classList.add("bstack-slider-dots-span");
            dot.innerHTML =
              '<button class="bstack-slider-dots-btn '+ (dotNumber === 1 ? 'active': '') +'" aria-label="Go to slide '+ dotNumber +'" '+ (dotNumber === 1 ? 'disabled="disabled"': '') +' data-index="'+ dotNumber +'">&nbsp;</button>';
            
            sel.querySelector(".bstack-slider-dots").appendChild(dot);
          }
        }

        var sliderDots = sel.querySelectorAll('.bstack-slider-dots-btn');
        for (var i = 0; i < sliderDots.length; i++) {
          for (var j1 = 1; j1 < cards.length; j1++) {
            var cardLinks = cards[j1].querySelectorAll("a, button");
            for (var k1 = 0; k1 < cardLinks.length; k1++) {
              cardLinks[k1].tabIndex = "-1";
            }
          }

          sliderDots[i].addEventListener(
            'click',
            function (evt) {
              evt.preventDefault();
              var that = this,
                cardWidth = carousel.querySelector("[data-target='card']").offsetWidth,
                slideIndex = parseInt(that.dataset.index) - 1;
              
              if (thatP.options.emptySpaceInLastSlide && slideIndex === maxSlide - 1) {
                offset = (slideIndex * -1 * ((cardWidth * numberOfCards) + (gap * numberOfCards))) + ((cardWidth + gap) * ((numberOfCards * maxSlide) - cardCount));
              } else {
                offset = slideIndex * -1 * ((cardWidth * slide) + (gap * slide));
              }
              carousel.style.transform = 'translateX('+ offset +'px)';

              if (leftButton) {
                leftButton.removeAttribute("disabled");
              }
              if (rightButton) {
                rightButton.removeAttribute("disabled");
              }

              if (slideIndex == 0 && leftButton) {
                leftButton.setAttribute('disabled', 'disabled');
              }
              if (slideIndex == maxSlide - 1 && rightButton) {
                rightButton.setAttribute('disabled', 'disabled');
              }

              //active class
              sliderDots = sel.querySelectorAll('.bstack-slider-dots-btn');
              for (var j = 0; j < sliderDots.length; j++) {
                sliderDots[j].removeAttribute("disabled");
                sliderDots[j].classList.remove("active");
                
              }
              that.classList.add("active");
              that.setAttribute('disabled', 'disabled');
              that.tabIndex = 0;

              for (var j = 0; j < cards.length; j++) {
                var cardLinks = cards[j].querySelectorAll("a, button");

                for (var k = 0; k < cardLinks.length; k++) {
                  if (j == slideIndex) {
                    cardLinks[k].tabIndex = "0";
                  } else {
                    cardLinks[k].tabIndex = "-1";
                  }
                }
              }

              thatP.slideIndex = slideIndex;
            },
            false
          );
        }
      }

      function leftCarouselSlide() {
        cardWidth = carousel.querySelector("[data-target='card']").offsetWidth;
        slideIndex = thatP.slideIndex;
        if (slideIndex > 0) {
          slideIndex--;
          if (slideIndex == maxSlide - 2 && (cardCount % slide) !== 0 ) {
            offset += (cardWidth * (cardCount % slide)) + (gap * (cardCount % slide));
          } else {
            offset += (cardWidth * slide) + (gap * slide);
          }
          carousel.style.transform = 'translateX('+ offset +'px)';

          //disable button
          if (slideIndex == 0 && leftButton) {
            leftButton.setAttribute('disabled', 'disabled');
          }

          //dots
          if (thatP.options.showDots) {
            sliderDots = sel.querySelectorAll('.bstack-slider-dots-btn');
            for (var j = 0; j < sliderDots.length; j++) {
              sliderDots[j].removeAttribute("disabled");
              sliderDots[j].classList.remove("active");
            }
            if (sliderDots[slideIndex]) {
              sliderDots[slideIndex].classList.add("active");
              sliderDots[slideIndex].setAttribute('disabled', 'disabled');
            }
          }

          thatP.slideIndex = slideIndex;
        }
      }

      function rightCarouselSlide() {
        cardWidth = carousel.querySelector("[data-target='card']").offsetWidth;
        slideIndex = thatP.slideIndex;
        if (slideIndex <= maxSlide - numberOfCards) {
          slideIndex++;
          if (slideIndex == maxSlide - numberOfCards && (cardCount % slide) !== 0 ) {
            offset -= (cardWidth * (cardCount % slide)) + (gap * (cardCount % slide));
          } else {
            offset -= (cardWidth * slide) + (gap * slide);
          }

          if(slideIndex <= maxSlide - 1 ) {
            carousel.style.transform = 'translateX(' + offset + 'px)';
          }

          //disable button
         if (slideIndex == maxSlide - numberOfCards && rightButton) {
            rightButton.setAttribute('disabled', 'disabled');
          }

          //dots
          if (thatP.options.showDots && slideIndex <= maxSlide - 1) {
            sliderDots = sel.querySelectorAll('.bstack-slider-dots-btn');
            for (var j = 0; j < sliderDots.length; j++) {
              sliderDots[j].removeAttribute("disabled");
              sliderDots[j].classList.remove("active");
            }
            if (sliderDots[slideIndex]) {
              sliderDots[slideIndex].classList.add("active");
              sliderDots[slideIndex].setAttribute('disabled', 'disabled');
            }
          }
          thatP.slideIndex = slideIndex;
        }
      }

      // Add the click events
      if (leftButton) {
        leftButton.setAttribute('disabled', 'disabled');
        rightButton.removeAttribute("disabled");
        leftButton.addEventListener('click', function() {
          rightButton.removeAttribute("disabled");
          leftCarouselSlide();
        });
      }
      if (rightButton) {
        rightButton.addEventListener('click', function() {
          leftButton.removeAttribute("disabled");
          rightCarouselSlide();
        });
      }

      if (thatP.options.autoplay) {
        setInterval(function () {
          if (thatP.slideIndex >= maxSlide - 1) {
            for (var index = 0; index < maxSlide; index++) {
              leftButton.click();
            }
          } else {
            rightButton.click();
          }
        }, thatP.options.autoplay);
      }

      //touch swipe
      carousel.addEventListener('touchstart', function (e) {
        touchstartX = e.changedTouches[0].screenX;
      }, {passive: true});

      carousel.addEventListener('touchend', function (e) {
        touchendX = e.changedTouches[0].screenX;
        
        //swipe left
        if (touchendX > touchstartX) {
          if (rightButton) {
            rightButton.removeAttribute("disabled");
          }
          leftCarouselSlide();
        }

        //swipe right
        if (touchendX < touchstartX) {
          if (leftButton) {
            leftButton.removeAttribute("disabled");
          }
          rightCarouselSlide();
        }
      }, {passive: true});
    }, // #! init
  };
  return Plugin;
});
